import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogComponent } from '../../../../shared/components/dialog/dialog.component';
import { AlertMessageComponent } from '../../../../shared/components/alert-message/alert-message.component';
import { TransactionService } from '../../services/transaction.service';
import { HttpClientTestingModule } from '@angular/common/http/testing';

@Component({
  selector: 'app-delete-transaction-dialog',
  standalone: true,
  imports: [CommonModule, DialogComponent, AlertMessageComponent, HttpClientTestingModule],
  templateUrl: './delete-transaction-dialog.component.html',
})
export class DeleteTransactionDialogComponent {
  @Input() show = false;
  @Input() showHeader: boolean = false;
  @Input() fileNumber: string | null = null;
  @Input() transactionId: number | null = null;
  @Output() close = new EventEmitter<void>();
  @Output() confirmDelete = new EventEmitter<{ transactionId: number}>();
  @Output() error = new EventEmitter<{ error?: any }>();

  constructor(private readonly transactionService: TransactionService) { }

  confirmChecked = false;

  onCancel() {
    this.close.emit();
    this.confirmChecked = false;
  }

  onDelete() {
    if (this.confirmChecked) {
      if (this.transactionId != null) {
        this.transactionService.deleteTransaction(this.transactionId).subscribe({
          next: () => {
            this.confirmDelete.emit();
          },
          error: (errorResponse) => {
            this.error.emit(errorResponse?.error);
          }
        });
      }
      this.confirmChecked = false;
    }
  }

  onCheckboxChange(event: Event) {
    this.confirmChecked = (event.target as HTMLInputElement).checked;
  }
} 